"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChartCfg = useChartCfg;
var React = _interopRequireWildcard(require("react"));
var _types = require("../types");
var _getChartConfig = require("./getChartConfig");
var _getTrendsChartConfig = require("./getTrendsChartConfig");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function useChartCfg(props, canvasCtx) {
  const chartCfg = React.useMemo(() => {
    if (!canvasCtx) {
      return null;
    }
    /** Если пропсы виджета меняются, создается новый конфиг для графика */
    switch (props.type) {
      case _types.EChartTypes.Default:
        return (0, _getChartConfig.getChartConfig)({
          props,
          ctx: canvasCtx
        });
      case _types.EChartTypes.Trends:
        return (0, _getTrendsChartConfig.getTrendsChartConfig)({
          props,
          ctx: canvasCtx
        });
      case _types.EChartTypes.SupplyDemand:
        return (0, _getTrendsChartConfig.getTrendsChartConfig)({
          props,
          ctx: canvasCtx
        });
      default:
        return (0, _getChartConfig.getChartConfig)({
          props,
          ctx: canvasCtx
        });
    }
  }, [canvasCtx, props]);
  return chartCfg;
}